import "./css/App.css";
import Home from "./pages/Home";
import NavBar from "./Component/NavBar";
import { Route, Routes } from "react-router-dom";
import Favorites from "./pages/Favorites";
import { MovieProvider } from "./context/MovieContext";
import Action from "./pages/Action";

function App() {
  return (
    <MovieProvider>
      <NavBar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/action" element={<Action />} />
        </Routes>
      </main>
    </MovieProvider>
  );
}

export default App;
